import React, { useEffect } from 'react';

type Props = {
  description: string;
  children: React.ReactElement;
  title: string;
};

export default function AppTemplate ({
  description = '',
  children,
  title = ''
}: Props) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    // @ts-ignore
    let el = document.getElementsByTagName('meta')?.['description'];
    if (el) { el.content = description; }
  }, [description]);

  return children;
}
